// For translators, please README-coffee.MD

// Dutch language file www.qrespi.com website
// gg
// @Author: Tom Voorneveld <root>
// @Date:   2016-10-17T15:01:53+02:00
// @Email:  tom@lorinthe.com
// @Project: Lorinthe
// @Last modified by:   tom
// @Last modified time: 2019-05-17T11:19:09+02:00
// @License: Copyright Lorinthe BV, The Netherlands. All rights reserved

var nl

nl = {
  title: {
    hashtags: 'zorg, veilig, alleenwonend',
    subtitle: 'Meer mensen leven alleen en gemeenschapszorg is niet langer vanzelfsprekend. Het is tijd te handelen…',
    alt: 'Qrespi International - Nederland'
  },
  intro: {
    embedvideo: {
      title: 'Alleenwonend?'
    },
    preorder: {
      payload: 'Steun ons productie-start-doel',
      progress: 'tot nu toe besteld',
      button: 'vooruit-bestel <b>30%&nbsp;korting</b>'
    },
    1: {
      title: 'Verbind voor zorg',
      payload: 'Qrespi ondersteunt <b>wederzijdse zorg</b>, met name tussen <b>alleenwonenden</b> en hun buren, vrienden en familie.'
    },
    2: {
      title: 'Puck by Qrespi™',
      list: {
        1: '<b>buren-attentie-knop</b>',
        2: '<b>veilig</b> voor <b>alleenwonenden</b>',
        3: 'tik op Puck &rarr; bericht een <b>chat groep</b>',
        4: 'geen reactie? Puck kan zelfs <b>iemand bellen</b>!',
        5: 'verrassend <b>betaalbaar</b>'
      },
      tooltip: {
        3: 'Puck kan het bericht naar een standaard chat groep sturen met familie, vrienden of buren. Je kunt kiezen voor Telegram, WhatsApp, Slack of Facebook Messenger'
      }
    },
    more: 'Lees meer over Puck'
  },
  puck: {
    label: 'puck',
    title: 'Meer over Puck',
    subtitle: 'Puck by Qrespi™',
    lead: 'Tap voor Zorg',
    about: {
      label: 'wat is Puck',
      title: 'Wat is Puck?',
      subtext: '"Puck by Qrespi™" is een klein apparaatje met een grote knop. Je bevestigt Puck bijvoorbeeld in de badkamer of naast de voordeur. Wanneer je op de Puck-knop tikt, stuur je onmiddellijk een attentie-bericht naar een chatgroep. <br/><br/>De vrienden, familie of buren die lid zijn van die chatgroep ontvangen je melding. Als het te lang duurt voor mensen om de attentie te zien, kan Puck zelfs een aantal geautomatiseerde telefoontjes plegen.'
    },
    workflow: {
      label: 'workflow',
      title: 'Workflow'
    },
    slides: {
      title: 'Veranderende maatschappij',
      1: {
        title: 'In de huidige maatschappij ...',
        caption: '… wonen veel mensen alleen'
      },
      2: {
        title: 'Er zijn momenten ...',
        caption: '… waarop we allemaal wat hulp kunnen gebruiken'
      },
      3: {
        title: 'Puck by Qrespi™ ...',
        caption: '… veilig en verbonden voelen'
      },
      4: {
        title: 'Om ons met elkaar te verbinden ...',
        caption: '... voor wederzijdse zorg en ondersteuning'
      }
    },
    specifications: {
      label: 'specificaties',
      title: 'Specificaties',
      payload: '',
      disclaimer: 'Betreft Puck-versie 1.0; wijzigingen zonder kennisgeving voorbehouden.',
      images: {
        1: {
          title: 'Exploded View'
        },
        2: {
          title: 'Dimensies'
        }
      },
      1: {
        label: 'fysieke dimensies',
        payload: 'afmeting: 65x65x16mm (2.6x2.6x0.63 "), gewicht: 80 gram (2,8 ounch) (bij benadering)'
      },
      2: {
        label: 'batterijen',
        payload: 'Puck wordt gevoed door 3 AAA-batterijen die je kunt vervangen door de behuizing te openen met een gewone kruiskop-schroevendraaier (PZ1)'
      },
      3: {
        label: 'waterbestendig',
        payload: 'Puck is waterbestendig, maar niet waterdicht. Je kunt het niet in bad nemen. Douchen zou moeten kunnen, maar we raden aan om Puck niet aan zeep oid. bloot te stellen, wat de afdichting zou kunnen aantasten. '
      },
      4: {
        label: 'aanraaktoetsen',
        payload: 'Puck heeft drie aanraaktoetsen. Ze zijn niet mechanisch. Puck bevat geen bewegende delen die kunnen slijten. Binnen Puck zijn er twee microschakelaars: om Puck opnieuw in de fabrieksstand te zetten of om verbinding te maken met WiFi. '
      },
      5: {
        label: 'materiaal',
        payload: 'Wit ABS (plastic), glanzend oppervlak'
      },
      6: {
        label: 'magneten',
        payload: 'Puck wordt geleverd met twee magneetjes aan de achterkant. Je kunt Puck aan elk stalen oppervlak bevestigen. Merk op dat roestvrij staal niet altijd voldoende magnetisch is: gebruik dan het metalen plaatje die je op het oppervlak plakt. '
      },
      7: {
        label: 'LED-balk',
        payload: 'Een bi-color, rood / groen, balkje met 10 LED\'s. Puck geeft de wifi-signaalsterkte aan met behulp van deze indicator. We gebruiken deze rij met LED\'s ook om af te tellen voordat een alarmsignaal klinkt. '
      },
      8: {
        label: 'LED-touch',
        payload: 'Naast elke aanraakknop hebben we een rode LED die oplicht wanneer je op die knop drukt.'
      },
      9: {
        label: 'geluid',
        payload: 'Een kleine luidspreker geeft audio-feedback met eenvoudige, door de gebruiker te selecteren melodieën.'
      },
      10: {
        label: 'labels',
        payload: 'PVC-zelfklevende sticker'
      }
    }
  },
  prices: {
    label: 'prijs',
    title: 'Prijzen',
    header: 'Wat kost het',
    lead: 'Puck is verrassend betaalbaar!',
    compare: {
      title: 'Service plan vergelijking',
      intro: 'Vergelijk het Gratis Plan met ons aanbevolen Care Plan.'
    },
    puck: {
      label: 'Puck',
      title: 'Je eigen Puck',
      slot: 'Voor een minimaal bedrag kunt u zich nog vele jaren veiliger voelen. Let op: we hebben tijdelijk een <b>korting van 30%</b>, dus reageer snel!',
      note: '* Prijzen kunnen zonder voorafgaande kennisgeving worden gewijzigd<br>** "Fair use" policy<br>*** 7x24 uur operationeel, maar houd er rekening mee dat er altijd technische problemen kunnen optreden<br>**** Afhankelijk van het land en je telefoonnummer, brengen wij additionele bel-kosten in rekening.',
      puck_set: {
        header: 'Jouw Puck',
        1: 'drie gekleurde stick-on-labels',
        2: 'magnetische, zelfklevende muurbevestigingsschijf',
        3: 'AAA-batterijen (3x)',
        4: 'snelstartgids',
        5: 'folders om te delen met buren',
        6: 'gratis plan',
        note: 'Bekijk je persoonlijke situatie!',
        pack: {
          label: 'Set met:',
          1: {
            note: 'Puck: voor kleinere appartementen.'
          },
          2: {
            note: 'Pucks: badkamer, voordeur?'
          },
          3: {
            note: 'Pucks :badkamer, keuken, voordeur, slaapkamer?'
          }
        }
      },
      free_plan: {
        header: 'Gratis Plan',
        1: 'gratis web-account',
        2: 'beheer je Puck en services',
        3: 'kies je eigen geluidseffecten',
        4: 'Puck 7x24 "heartbeat"***',
        5: 'alleen voor <a href="https://www.telegram.org" target="_blank">Telegram</a>',
        6: 'maximaal één bericht per dag**',
        note: 'Eenvoudig!',
        pack: {
          label: 'Onze dagelijkse service:',
          1: {
            contains: 'Puck free',
            note: 'operationele dienst'
          }
        }
      },
      standard_plan: {
        header: 'Care Plan',
        1: 'alles van het Gratis Plan',
        2: 'automatische follow-up berichten',
        3: 'automatische robot oproepen',
        4: ' <a href="https://www.telegram.org" target="_blank">Telegram</a>, WhatsApp, FB Messenger',
        5: 'ongelimiteerd aantal attentie-berichten **',
        note: 'Aanbevolen!',
        pack: {
          label: 'Betaling:',
          1: {
            contains: 'jaarlijks',
            note: 'maandelijks bedrag wanneer je <u>per jaar</u> vooruit betaalt'
          },
          2: {
            contains: 'maandelijks',
            note: 'maandelijks bedrag wanneer je <u>per maand</u> betaalt'
          }
        }
      }
    }
  },
  preorderpuck: {
    label: 'pre-order',
    title: 'Puck\'s Vooruitbestel-wachtlijst',
    subtitle: 'Schrijf je in',
    lead: 'Meld je aan op onze "vooruitbestel-wachtlijst" en ontvang een aanzienlijke korting!',
    slot: 'Geef je <b>nu</b> op, het duurt één minuut en je komt in aanmerking voor:',
    form: {
      title: 'Schrijf je vrijblijvend in op onze wachtlijst',
      topic: {
        label: 'Hoeveel Pucks zou je willen kopen?',
        placeholder: 'Selecteer mogelijke interesse ...',
        1: '1x: Eén Puck',
        2: '2x: Set met twee Pucks',
        4: '4x: Set met vier Pucks',
        other: 'Anders (schrijf ons een bericht)'
      }
    },
    list: {
      1: 'als eerste om een ​​Puck te krijgen als we beginnen met produceren',
      2: '30% introductiekorting van <a href="/prices/Puck">bij aanschaf één of meer Pucks</a>',
      3: 'we houden je op de hoogte van onze voortgang (maximaal één e-mail per twee weken)',
      4: 'je verplicht je tot niets!',
      5: 'je moedigt ons aan om de ontwikkeling te versnellen - bij voorbaat dank!'
    },
    why: {
      title: 'Waarom op voorhand inschrijven?',
      1: 'Puck is nog niet beschikbaar voor aankoop. Om de belangstelling te peilen, zijn wij een register voor reserveringen gestart. Deze reserverings-registratie staat los van onze nieuwsbrief en is uitsluitend bedoeld om een ​​plaats op onze wachtlijst te reserveren. ',
      2: 'De wachtlijst is voor Puck\'s <b>toekomstige klanten</b>. Er wordt in dit stadium geen betalingsinformatie verzameld en er is <b>geen verbintenis</b>. Registratie verhoogt alleen prioriteitsniveau voor de eerste productie-serie. ',
      3: 'Daarnaast bieden we je eenmalig <b>30% korting</b> wanneer je daadwerkelijk besteld',
      4: 'We houden contact met spamvrije updates en meer informatie wanneer we iets substantieels te melden hebben.',
      5: 'Indien nodig, voor meer informatie:'
    }
  },
  services: {
    compare: {
      title: 'Service plan vergelijking',
      intro: 'De volgende tabel laat zien welke service wordt aangeboden door ons "Free Plan" versus "Care Plan"'
    },
    table: {
      row: {
        text: 'Bekijk onze prijzen',
        1: {
          label: 'Puck Heartbeat',
          title: 'Puck werkt betrouwbaar 24x7',
          block: 'Ik voel me veilig omdat ik weet dat Puck online is.',
          slot: 'Het is onze verantwoordelijkheid om Puck elke dag en nacht te laten werken. Onze communicatieservers moeten dus dag en nacht functioneren. Echter, realiseer je dat net als bij andere online-technologie er momenten van onderbreking kunnen zijn. <br><br><b>Let op: Puck is géén vervanging van de officiële hulpinstanties of alarmoproepen. Bel altijd 112 in geval van nood!</b>'
        },
        2: {
          label: 'Webaccount',
          title: 'Webaccount om je Puck te configureren',
          block: 'Eén webaccount om al je Pucks in te stellen',
          slot: 'Met Puck krijg je een persoonlijk, uniek "connect to care" web-account. In dit web-account kun je al je Pucks programmeren:<br> - het bericht dat Puck moet versturen<br> - kies een chatapp: Telegram / WhatsApp<br> - nodig Qrespi uit in de chatgroepen<br>- kies een persoon en mobiel nummer voor de automatische oproep (robot-stem) en de tijd die verstreken moet zijn voor dat Puck gaat bellen<br> - selecteer het geluid die Puck moet maken als je op de knop drukt<br> - selecteer welke kleur de LED\'s moeten knipperen als je op de knop drukt<br> - bepaal of je een periodieke automatische test wilt hebben van Puck '
        },
        3: {
          label: 'Geluidseffecten',
          title: 'Audiofeedback na het aanraken van de knop',
          slot: 'Je kunt kiezen of Puck eventueel een geluid moet maken als je op de knop drukt. Je kunt voor elk van je Pucks een andere melodie selecteren. ',
          block: 'Licht en geluidseffecten geven aan wat er gebeurt'
        },
        4: {
          label: 'Familie- en vrienden- alerts - Telegram',
          title: 'Zorg- en ondersteunings-berichten verzonden via Telegram',
          slot: 'De belangrijkste service van Puck is het versturen van meldingen naar chatgroepen. De chatgroep en de meldingstekst kun je zelf in je web-account instellen. De kosten van een attentie-bericht is afhankelijk van de chat app die je gebruikt.<br><br>We hebben de voorkeur voor <a href="http://telegram.org">Telegram</a>. Telegram is een chat app net zoals WhatsApp, veilig en in tegenstelling tot WhatsApp ook gratis voor bedrijven: Qrespi.',
          block: '"Fair use policy", dus laat kinderen geen piano spelen op je Pucks.'
        },
        5: {
          label: 'Family & Friend Alerts - WhatsApp',
          titel: 'Care and Support Alerts by WhatsApp & andere chat-apps',
          slot: 'Deze service is hetzelfde als de vorige, maar in plaats van Telegram kunnen je vrienden en familie berichten ontvangen in een WhatsApp groep. Helaas kunnen we dit niet gratis aanbieden: om berichten van WhatsApp of Messenger te bezorgen, is Facebook van plan om bedrijven kosten in rekening te brengen en beperkingen op te leggen aan wat we kunnen verzenden. Dit is jammer, want het belemmert ons om via WhatsApp alerts te verzenden als onderdeel van het gratis plan. ',
          block: '"Fair use policy", dus laat kinderen geen piano spelen op je Pucks.'
        },
        6: {
          label: 'Geautomatiseerde follow-up attentie-berichten',
          title: 'Aanvullende attentie-berichten',
          slot: 'Wat als je op Puck tikt om een melding naar een chatgroep te sturen en niemand in die chatgroep het bericht opent? Qrespi kan de optie bieden om een tweede of derde bericht naar een andere chatgroep te sturen, zelfs in een andere chat app met verschillende mensen. Je vergroot de kans dat iemand je melding ziet. ',
          block: 'Extra aandacht van mensen die voor je zorgen.'
        },
        7: {
          label: 'Geautomatiseerde robot-oproepen',
          title: 'Extra zorg door automatisch bellen',
          slot: 'Wat als alle mensen in je "zorg-groep" hun meldingen op "stil/mute" hebben? Als niemand het attentie-berichten binnen bijvoorbeeld 60 seconden leest, kan Qrespi automatisch een voorkeurs-persoon bellen. ',
          block: 'Extra aandacht van mensen die voor je zorgen.'
        },
        8: {
          label: 'Check in / Check Out',
          title: 'Tijdslimieten en drempels voor acties',
          slot: 'Met deze service kun je een bepaalde tijd en frequentie configureren wanneer je een tik op de knop kunt verwachten. U kunt bijvoorbeeld oma vragen om vóór 11 uur\'s avonds op Puck te tikken. Nu krijg je alléén een melding als ze vóór die tijd niet op Puck heeft getikt. Er zijn eindeloos veel toepassingen voor deze service, bijvoorbeeld dat ouders hun tienerdochter zelfs vertellen dat ze op Puck tikken als ze thuiskomen. Dus alleen als ze\'s nachts voor een bepaalde tijd thuiskomen, zal Puck de ouders niet wakker maken...',
          block: 'Plan het leven, maar zonder ongewenste bemoeienis.'
        },
        9: {
          label: 'Periodiek testen',
          title: 'Periodieke automatische test',
          slot: 'Periodiek, bijvoorbeeld elke week of maand, kun je Puck automatisch laten testen. Je wilt er tenslotte zeker van zijn dat attentie-berichten en robot-oproepen goed doorkomen. Op een dag en tijd die je selecteert, stuurt Puck je een automatische testbericht met de opdracht:<br>- om op een van de bovenste knop van Puck te drukken<br>- om het bericht te controleren die je daarna zou moeten ontvangen<br>- tegelijk wordt ook de batterijstatus en WiFi signaal sterkte doorgegeven.<br>- om op de onderste knop te drukken om het robot-gesprek te controleren: een oproep naar de persoon die je als ontvanger hebt gekozen.',
          block: 'Wees gerust dat alles werkt en ook blijft werken!'
        }
      }
    }
  },
  solutions: {
    label: 'oplossingen',
    consumer: {
      label: 'consumenten',
      title: 'waar gebruik je Puck?',
      header: 'Touch to Care',
      lead: 'Oplossingen voor het dagelijks leven',
      payload: 'Eigenlijk kan je in de meeste kamers waar je je kunt voorstellen dat er iets kan gebeuren, een Puck installeren.',
      quote: 'Met Puck vraag je je buren om je te helpen, net zoals je hen kunt helpen&hellip;',
      1: {
        label: 'voordeur',
        title: 'Veilige voordeur',
        intro: 'Een typische toepassing is voor mensen die zich veiliger moeten voelen bij hun eigen voordeur. Met een attentie-bericht kun je een buurman laten komen voor hulp.'
      },
      2: {
        label: 'badkamer',
        title: 'Badkamer attentie',
        intro: 'Meer dan 60% van alle ongevallen gebeuren thuis in de badkamer. Een Puck naast de douche of het bad kan het verschil maken. '
      },
      3: {
        label: 'tuin',
        title: 'Zorg in de tuin',
        intro: 'Zolang je binnen bereik van je wifi blijft, kun je Puck meenemen naar plaatsen in en rond het huis. Draag Puck echter niet in je zak; de aanraakknop is gevoelig.'
      },
      4: {
        label: 'keuken',
        title: 'Aandacht in Keuken',
        intro: 'Na de badkamer is de keuken een tweede plek waar je misschien iemand wilt attenderen.'
      },
      5: {
        label: 'slaapkamer',
        title: 'Welterusten',
        intro: 'Verbinden met zorg kan ook een tikje betekenen voor een positief teken van aandacht ... Ik denk aan je, welterusten!'
      }
    },
    business: {
      label: 'bedrijven & organisaties',
      title: 'Bedrijven en Organisaties',
      header: 'Dienstbaar aan klanten & leden',
      lead: 'Bedien uw klanten met efficiënte connect-to-care oplossingen',
      slot: 'We bespreken graag mogelijke samenwerking met uw organisatie.',
      type: {
        0: {
          title: 'Selecteer uw bedrijf'
        },
        1: {
          label: 'thuiszorg',
          title: 'Thuiszorgorganisaties',
          slot: 'Voor organisaties die mensen met speciale behoeften ondersteunen bij het zelfstandig thuis wonen. Dit kan zijn voor mensen die ouder worden, chronisch ziek zijn, herstellen van een operatie of gehandicapt zijn. '
        },
        2: {
          label: 'zorg & gezondheid',
          title: 'Gezondheidszorg',
          slot: 'Voor klinieken en ziekenhuizen die mensen met chronische ziekten gezondheidszorg bieden.'
        },
        3: {
          label: 'verzekering',
          title: 'Zorgverzekeraars',
          slot: 'Voor bedrijven die zorgverzekeringen aanbieden, voor mensen die zelfstandig thuis wonen.'
        },
        4: {
          label: 'zorg-consultant',
          title: 'E-health consultants',
          slot: 'Voor adviesbureaus die kennis aanbieden voor het verbeteren van technologie-integratie in gemeentes en zorgpraktijken.'
        },
        5: {
          label: 'overheid',
          title: 'Gezondheidsafdelingen van gemeenten',
          slot: 'Gemeenten die zelfstandig wonenden ouderen ondersteunen door hen toegang te bieden tot moderne technologie, praktisch advies of financiële ondersteuning.'
        },
        6: {
          label: 'retail',
          title: 'Gezondheidszorg - online winkels en speciaalzaken',
          slot: 'Voor zowel winkels die zorg-hulpmiddelen als winkels die consumenten goederen zoals badkamers rechtstreeks aan consumenten verkopen. Qrespi helpt een moderne "connect-to-care-service provider" te worden. '
        },
        7: {
          label: 'community',
          title: 'Buurtgemeenschappen',
          slot: 'Voor verenigingen die hun wijk met zorg of veiligheid ondersteunen.'
        }
      },
      usp: {
        1: {
          title: 'Escalatiepreventie',
          slot: 'Laat een ongelukje niet van kwaad tot erger komen. We hebben vastgesteld dat u aanzienlijke kostenbesparingen kunt realiseren door escalatie van noodsituaties te voorkomen. Bijvoorbeeld onnodig bellen van 911 bij een milde paniekaanval. '
        },
        2: {
          title: 'Triviale assistentie uitbesteden',
          slot: 'Het is mogelijk om een ​​aanzienlijke kostenbesparing te realiseren door triviale hulp aan familie en buren "uit te besteden".'
        },
        3: {
          title: 'Werklast vermindering',
          slot: 'Verminder werklast door gezinnen en buren te betrekken bij triviale zorgsituaties.'
        },
        4: {
          title: 'Deel praktische kennis',
          slot: 'Geef patiënten praktische begeleiding voor hun veiligheid en comfort, zelfs met een beperkt budget.'
        },
        5: {
          title: 'Word een dienstverlener',
          slot: 'Her-positioneer als dienstverlener, in plaats van louter productverkoper, betrek de veiligheid van uw klant en bereik meer totale waarde.'
        },
        6: {
          title: 'Oplossing voor comfort',
          slot: 'Een voorbeeld: een sanitair-winkel biedt Pucks een sterke korting met elke badkamer of keuken die een senior koopt.'
        },
        7: {
          title: 'Verhoog het gevoel van comfort',
          slot: 'Verminder de angst van de tweede generatie met zorgzekerheid voor hun (eenzame) ouders'
        },
        8: {
          title: 'Verminder ruis in de groep',
          slot: 'Veel buurtgemeenschappen hebben te maken met een grote hoeveelheid "ruis". Puck helpt mensen zich te concentreren op actuele noodsituaties'
        },
        9: {
          title: 'Investeringskansen',
          slot: 'Geweldige investeringskans in sterk groeiende markt'
        },
        10: {
          title: 'Sociale hechting',
          slot: 'Vergroot de sociale connectie tussen ouderen (gemeenschappen) bij het inrichten van hun huis met maximale zorg en aandacht voor veilig en zelfstandig ouder worden'
        },
        11: {
          title: 'Positieve PR',
          slot: 'Bevorder echte interesse in klantwelzijn met onze goedkope, maar uitstekend herkenbare "connect-to-care"-oplossing'
        }
      }
    }
  },
  technology: {
    label: 'technologie',
    header: {
      title: 'Technologie',
      subtitle: 'De uitdaging',
      lead: 'optimale ervaring '
    },
    software: {
      title: 'Software',
      payload: 'Bij het ontwikkelen van apps is een van de grootste uitdagingen het kiezen van de beste programmatie <b>bibliotheken </b>en <b>frameworks </b>. Ons succes in deze uitdaging is een van onze grootste troeven. <br/><br/>Let op <b>dit is een dynamische lijst </b>; voorkeuren veranderen in de tijd als gevolg van marktsituaties en ontwikkeling. ',
      1: {
        label: 'Web Apps',
        icon: 'mobiel',
        title: 'Web Apps',
        slot: '"Een web-toepassing is een computerprogramma dat webbrowsers en web-technologie gebruikt voor het uitvoeren van taken via internet." Een belangrijk voordeel van deze aanpak is dat ontwikkelaars niet langer meerdere apps op meerdere platforms hoeven te ontwikkelen. Zelfs voor degenen die zich alleen voor iOS en Android ontwikkelen, betekent dit enorme besparingen in tijd en moeite. ',
        plus: {
          1: 'één codebasis voor alle platforms',
          2: 'eerst mobiel',
          3: 'uitstekende prestaties',
          4: 'responsief ontwerp',
          5: 'geen geheugenverlies voor installatie',
          6: 'gedeeld met url',
          7: 'distribueer nog steeds in app / Play Stores',
          8: 'automatische updates'
        }
      },
      2: {
        label: 'PWA',
        icon: 'retweet',
        title: 'Progressive Web Apps',
        slot: 'Een Progressive Web App is een webapp die vergelijkbare functionaliteit en een <b>naadloze gebruikersinterface </b>biedt die te vinden is in de beste native apps; een ervaring die voorheen moeilijk te bieden was. Het is belangrijk om te beseffen dat PWA \'s <b>geen hybride </b>apps zijn! Hybride apps zijn afhankelijk van een tussenliggende, niet-standaard laag tussen de app en het apparaat. Dit zal leiden tot een ontwikkelingsproces <b>locked </b>. <br/><br/>Lees wat Google te zeggen heeft over <a href = "https://developers.google.com/web / progressive-web-apps / "target =" _ blank ">Progressive Web Apps </a>. ',
        block: 'We verwachten dat progressieve web-apps de volgende grote stap zijn voor mobiel internet. Het trekt veel aandacht vanwege het relatieve gemak van ontwikkeling en bijna directe winst voor de gebruikerservaring van de applicatie. ',
        plus: {
          1: '"progressief": direct laden',
          2: 'push-meldingen (native mobile)',
          3: 'blijft off line',
          4: 'snel',
          5: 'pictogrammen van startscherm op Android',
          6: 'verschillende mobiele hardware-interfaces',
          7: 'native apps benaderen'
        }
      },
      3: {
        label: 'Vue.js',
        icon: 'code',
        title: 'VueJS Front-End Framework',
        slot: 'Vue.js is, laten we eerlijk zijn, een <b>kick ass-framework </b>. En het gaat niet alleen om het schrijven van geweldige code. Je hebt uitstekende documentatie nodig, een sterke community die elkaar helpt te leren, een ondersteunende cast van bibliotheken en plug-ins om gebruikers te helpen de harde problemen op te lossen, en korte feedbacklussen op basis van feedback van gebruikers om het kader relevant te houden. Vue.js is dat allemaal, plus geweldige code. Dat is waarom we het gebruiken. ',
        block: 'Als front-end web-ontwikkelaar kan ik met geweldige mensen op de werkplek werken en feedback krijgen voor mijn ideeën in de grotere ontwikkelaarsgemeenschap. Ik ben dol op front-end development ... en Vue.js! ',
        image: 'vuejs.svg',
        plus: {
          1: 'templating - toegang tot .js met {{}}',
          2: 'reactiviteit - alle automatische UI-updates',
          3: 'componenten - inkapselen van gedrag',
          4: 'gebruik standaard ES6 JavaScript-regels (!)'
        }
      },
      4: {
        label: 'Staat',
        icon: 'tafel',
        title: 'State Management',
        slot: 'Hoewel het basisconcept zo oud is als de weg naar Rome, is <i>state management</i>in de front-end software al lang verwaarloosd. Nu, sinds een paar jaar, is het terug en beter dan ooit. <br/><br/>Eigenlijk is een "staat" "één bron van waarheid" voor alle activiteiten aan de voorkant. Alle logica, inclusief de back-endserver, <i>alleen</i>communiceert via de <i>status</i>. Dit verschil is niet zo zichtbaar met slechts enkele componenten, maar zeer indrukwekkend wanneer het aantal verbindingen groeit. We accepteren niet langer deep links of zogenaamde "AJAX call spaghetti" ... Refreshing !! ',
        block: 'Staatsbeheer stelt Lorinthe in staat zich te concentreren op de gebruikersinterface. Een goed gedocumenteerde status-container maakt verbinding met andere delen van de applicatie. Het stelt andere softwareontwikkelaars in staat zich te concentreren op de toepassingslogica en het saaie UI-werk uit te besteden. ',
        image: 'state-management.svg',
        plus: {
          1: 'Behoud de status van gebruikersinterface, zoals het open of gesloten houden van de zijbalk bij het wijzigen van routes.',
          2: 'Beheer de gebruikersinterface vanaf elk punt van de toepassing zonder je zorgen te maken over de manier waarop componenten gerelateerd zijn of hoe je een specifieke service injecteert.',
          3: 'Chain UI-opmaakspecifieke acties met andere gebeurtenissen, zoals gegevensserver opslaan of een route wijzigen'
        }
      },
      5: {
        label: 'Node.js',
        icon: 'file-code-o',
        title: 'Node.js - JavaScript aan de serverzijde',
        slot: 'JavaScript is de taal voor het toevoegen van interactiviteit aan een website, maar er is zoveel meer dat het kan doen. Voer Node.js en Express.js in, twee technologieën die de mogelijkheden van JavaScript uitbreiden. Met het platform kunt je <b>server </b>-side-toepassingen ontwikkelen met JavaScript die je vervolgens gemakkelijk kunt publiceren als websites met het Express-framework. ',
        block: 'Ik ben constant en aangenaam verrast dat Node.js voor wat voor tool of demonstratie dan ook die ik nodig heb, hoe complex ook, mijn leven enorm vereenvoudigt!',
        image: 'node.svg',
        plus: {
          1: 'één taal voor zowel server als client',
          2: 'high performance',
          3: 'eenvoudig te schalen',
          4: 'snelle levering',
          5: 'sublime npm-pakketbeheer'
        }
      },
      6: {
        label: 'Realtime DB',
        icon: 'database',
        title: 'Open-source databases voor het realtime web',
        slot: 'Slechts enkele jaren geleden was databasewerk een van de saaiste taken in de IT - op een goede manier. Gegevens gingen naar een van de grote SQL-databases en die kwamen later allemaal uit één stuk, precies zoals het erbij was gegaan. De makers van de database waren erin geslaagd om solide prestaties te leveren en iedereen begon het als vanzelfsprekend te beschouwen. <br/><br/>Toen veranderde de aard van wat we wilden opslaan. Databases moesten verder gaan dan bankrekeningen en vliegtickets omdat iedereen was begonnen met het delen van gegevens op sociale netwerken. Plots waren er veel meer gegevens om op te slaan en de meeste van deze nieuwe gegevens pasten niet in de oude tabellen. Het werk van databasemanagers en -ontwerpers is getransformeerd en wat naar voren is gekomen, is een breed scala aan intrigerende oplossingen die helpen databases tot de meer intrigerende technologieën van vandaag te maken. ',
        block: 'Lorinthe is gespecialiseerd in deze moderne databases: het is een plezier om met hen samen te werken en het eindresultaat is snel en flexibel.',
        plus: {
          1: 'RethinkDB',
          2: 'MongoDB',
          3: '... en anderen'
        }
      },
      7: {
        label: 'Nginx',
        icon: 'server',
        title: 'Nginx Web en proxyserver',
        slot: 'Nginx is een gratis open-source, krachtige HTTP-server. Het is niet alleen geschikt voor webserving, maar ook voor reverse proxy, caching, taakverdeling, mediastreaming en meer. ',
        block: 'We gebruiken Nginx in veel van onze PWA-gerelateerde projecten voor het simpele feit dat er in slechts enkele minuten een eenvoudige maar zeer effectieve high availability-instelling wordt gemaakt. ',
        plus: {
          1: 'high performance',
          2: 'stabiliteit',
          3: 'rich feature set',
          4: 'eenvoudige configuratie',
          5: 'laag verbruik van hulpbronnen'
        }
      },
      8: {
        label: 'Docker',
        icon: 'raket',
        title: 'Docker',
        slot: 'Docker-containers verpakken een stukje software in een compleet bestandssysteem dat alles bevat wat nodig is om te draaien: code, runtime, systeemtools, systeembibliotheken - alles dat op een server kan worden geïnstalleerd. Dit garandeert dat de software altijd hetzelfde zal draaien, ongeacht de omgeving. <br/>Docker biedt dezelfde mogelijkheid zonder de overhead van een virtuele machine. Hiermee kunt je omgeving en configuratie in code omzetten en implementeren. <br/>Lorinthe helpt je bij het opzetten en onderhouden van containers. ',
        block: 'Docker-containers zorgen voor consistentie in de turbulente wereld van software-ontwikkelomgevingen.',
        plus: {
          1: 'Standaardisatie & productiviteit',
          2: 'Compatibiliteit & onderhoudbaarheid',
          3: 'Eenvoud en snellere configuraties',
          4: 'Rapid Deployment',
          5: 'Isolatie en beveiliging'
        }
      },
      9: {
        label: 'Linux',
        icon: 'linux',
        title: 'Ubuntu & Linux gebaseerde besturingssystemen',
        slot: 'Ubuntu is een op Debian gebaseerd Linux-besturingssysteem voor personal computers, tablets en smartphones. Sinds 2008 werken we <b>exclusief </b>met dit besturingssysteem. <b>Iedereen </b>in het bedrijf, van ontwikkelaars tot secretaresses, gebruikt een ander besturingssysteem. <br/><br/>Niet alle Windows- of Mac-applicaties draaien op Ubuntu, maar er zijn altijd goede alternatieven of beter zelfs: <b>cloud-gebaseerde oplossingen </b>. De bakker eet zijn eigen brood;) ',
        blok: 'Wij <b>houden allemaal van Ubuntu! </b>. Het is zeer productief, veilig, snel en dagelijks plezierig om te gebruiken. ',
        image: 'ubuntu.svg',
        plus: {
          1: 'open source',
          2: 'veilig - geen viruslawine',
          3: 'veelzijdig',
          4: 'stabiel - stabiel - stabiel',
          5: 'compact - draait nog steeds snel op oudere hardware'
        }
      },
      10: {
        label: 'Chat',
        icon: 'telegram',
        title: 'Messaging Apps als het nieuwe besturingssysteem?',
        slot: 'Chat-apps werden de enabler van allerlei diensten als een natuurlijke uitbreiding van onze dagelijkse toolbox. Lorinthe heeft ruime ervaring en heeft een veelzijdig <b>platform voor chat-integratie </b>ontwikkeld. ',
        block: 'Neem contact met ons op en we kunnen bespreken hoe weservice kunnen koppelen binnen een snelle en effectieve infrastructuur voor berichten-apps.',
        image: 'qrespi-workflow.svg',
        plus: {
          1: 'omni-present: we gebruiken het allemaal',
          2: 'snel',
          3: 'direct',
          4: 'GRATIS'
        }
      },
      11: {
        label: 'Trello',
        icon: 'trello',
        title: 'Trello - Projectbeheer',
        slot: 'Trello is een geweldige tool voor projectmanagement die samenwerking eenvoudig en, laten we zeggen, zelfs leuk maakt. Bovenop het projectbeheer kan deze visuele lijsttool zoveel meer doen, of je nu werkprojecten, gezinsklussen, reisplannen of zo ongeveer alles organiseert. <br/>We vinden het leuk, omdat Trello alles heeft je moet projecten van elke grootte organiseren. We kunnen echter elke projectmanagementtool of bug-tracker gebruiken. ',
        block: 'Man, ik ben dol op Trello. Het is een gratis, eenvoudig te gebruiken, collaboratieve en zeer visuele tool met meer dan 10 miljoen gebruikers over de hele wereld. Ik gebruik het om zowel mijn persoonlijk als professioneel leven te helpen organiseren ',
        plus: {
          1: 'borden; één bord per project ',
          2: 'lijsten; elk suggereert een fase ',
          3: 'kaarten; volgorde bepaalt prioriteit ',
          4: 'GRATIS'
        }
      },
      12: {
        label: 'Agile',
        icon: 'stethoscoop',
        title: 'Agile Project Management',
        slot: 'Agile-methoden kwamen voort uit de real-life projectervaringen van toonaangevende softwareprofessionals die de uitdagingen en beperkingen van de traditionele watervalontwikkeling op project na project hadden ervaren. De aanpak die wordt gepropageerd door agile ontwikkeling is een directe reactie op het probleem in verband met traditionele softwareontwikkeling, zowel in termen van algemene filosofie als van specifieke processen. ',
        block: 'We geloven in korte cycli met onmiddellijke resultaten, die we elke dag kunnen testen.',
        image: 'scrum_process.svg',
        plus: {
          1: 'Betrokkenheid van belanghebbenden',
          2: 'Transparantie',
          3: 'Vroege en voorspelbare levering',
          4: 'Voorspelbare kosten en planning',
          5: 'Staat voor verandering toe',
          6: 'Concentreert zich op zakelijke waarde',
          7: 'Richt zich op gebruikers'
        }
      }
    },
    hardware: {
      title: 'Hardware',
      payload: 'Qrespi maakt gebruik van de modernste hardwareontwerp- en productietools.',
      1: {
        label: '3D CAD',
        title: '3D Parametric Modeler',
        slot: 'Om de Puck en andere hardware te ontwerpen, gebruiken we 3D-ontwerp,"Computer Aided Design"-software of "CAD" ',
        plus: {
          1: 'interactief ontwerp',
          2: 'extreem hoge nauwkeurigheid',
          3: 'kracht- en krachtberekeningen',
          4: 'automatische tekening updates',
          5: 'export van exacte modellen voor CAM'
        }
      },
      2: {
        label: 'Elektronica',
        title: 'Electronics Prototyping',
        slot: 'We gebruiken allerlei algemene hulpmiddelen voor ons elektronische ontwerp.',
        plus: {
          1: 'breadboards',
          2: 'sensoren',
          3: 'case materials',
          4: 'oscilloscoop, multi-meter',
          5: 'microscopen',
          6: 'SMD ovens'
        }
      },
      3: {
        label: 'Prototyping',
        title: '3D Printing Prototyping',
        slot: 'We gebruiken speciale 3D-afdrukken met ultrahoge resolutie.',
        plus: {
          1: 'materiaal jet printen',
          2: 'UV-verharding',
          3: 'ultra hoge resolutie',
          4: '1 dag draai rond tijd'
        }
      },
      4: {
        label: 'Injection Moulding',
        title: 'Weinig volume spuitgieten',
        slot: 'Om lage volumes van onze Puck te testen, gebruiken we Silicon Mallen. Met deze mallen kunnen we series van ongeveer 40-50 eenheden produceren om te testen. ',
        plus: {
          1: 'lage volumes',
          2: 'hetzelfde resultaat als hoogvolume producten',
          3: 'voor testen door eindgebruikers'
        }
      }
    }
  },
  testimonial: {
    title: 'wat mensen zeggen',
    1: 'Dame op leeftijd: dit is een gat in de markt. Ik wil er één voor elke kamer in mijn huis.',
    2: 'Jonge studente, alleenwonend: Puck zorgt ervoor dat ik me veiliger voel wanneer iemand\'s avonds laat aanbelt.',
    3: 'Senior man, in goede gezondheid: al die rode alarmknoppen die je om je nek zou moeten dragen? Ik ben niet gehandicapt! Een muurknop om op te slaan, is alles wat ik nodig heb.'
  },
  contact: {
    label: 'contact',
    title: 'neem contact op',
    caption: 'Stuur ons een bericht, we zullen zo snel mogelijk antwoorden.',
    name: {
      label: 'Je naam:',
      placeholder: 'Vul je volledige naam in',
      description: ''
    },
    email: {
      label: 'E-mail adres:',
      placeholder: 'jij@domein.com',
      description: 'We zullen je e-mail nooit met iemand anders delen.'
    },
    topic: {
      label: 'Onderwerp /keuze',
      placeholder: 'Selecteer een onderwerp',
      description: '',
      list: {
        1: 'Claim je introductie-korting voor Puck',
        2: 'Stuur mij meer informatie over Puck',
        3: 'Voor bedrijven, OEM, dealers, organisaties',
        4: 'Support en klantenondersteuning',
        5: 'Vacatures',
        6: 'Perscontact',
        7: 'Overig'
      }
    },
    message: {
      label: 'Bericht',
      placeholder: 'Eventueel bericht hier ...',
      description: ''
    },
    socialmedia: {
      share: 'Deel deze pagina',
      follow: '...of volg ons op:',
      twitter: '@qrespi Puck by Qrespi - Touch to Care - Een efficiënte veiligheidsknop.'
    }
  },
  responseform: {
    title: 'Contactformulier',
    ok: 'Vriendelijk dank. We nemen zo snel mogelijk contact met je op. ',
    failed: 'Sorry, er is iets mis gegaan bij het indienen van formulier ...',
    both: 'Als je wilt kunt je ons ook een <b><a href="mailto:info@qrespi.com?subject=Qrespi Contact formulier">e-mail </a></b>sturen. '
  },
  about_us: {
    label: 'over ons',
    header: {
      title: 'Over ons',
      subtitle: 'Wij geloven',
      lead: 'Happiness | een continue stroom van prestaties '
    },
    body: {
      intro: 'Qrespi International is een internationale <i>"connect to care"-IT dienstverlener </i> met het hoofdkantoor in Nederland.',
      usp: {
        1: 'Lorinthe, moederbedrijf, sinds 1995',
        2: 'wereldklasse <b>webapps </b>voor gezondheid, zorg en levensstijl',
        3: 'bewezen: duizenden dagelijkse gebruikers',
        4: 'internationale aanwezigheid'
      }
    },
    specialize: {
      title: 'Specialisatie',
      slot: 'Met jarenlange ervaring ontwikkelen, testen en beheren we moderne webgebaseerde applicaties en op microcontrollers gebaseerde hardware. Onze ontwikkelaars zijn gespecialiseerd in (Progressive) Web Apps en "Internet of Things". Wij zijn een groot voorstander van open source software.'
    },
    team: {
      // title: 'Team'
      intro: 'Het team van Qrespi biedt tientallen jaren aan uitgebreide branchekennis en -ervaring, plus een goed zakelijk perspectief.',
      1: {
        title: 'oprichter & ceo',
        slot: 'Met meer dan 25 jaar ervaring in IT, softwareontwikkeling, mobiele technologie, marketing en verkoop, leidt Tom Qrespi. Hij achtergrond in bedrijfskunde en technische informatica. '
      },
      2: {
        title: 'hardware liason',
        slot: 'Gena heeft bijna 30 jaar ervaring in softwareontwikkeling en elektronicaontwerp. Zijn specialisatie in transmissie elektronica maakt hem de perfecte kandidaat voor Qrespi, inter-communicatie en het "internet der dingen".'
      },
      3: {
        title: 'oprichter, marketing & operations',
        slot: 'Anna heeft een achtergrond in merkbeheer en consumentenproducten. Ze heeft een wonderbaarlijk oog voor detail en een grote passie voor het succes van Qrespi. Binnen Qrespi houdt zij toezicht op marketing en onze operationele activiteiten. '
      },
      4: {
        title: 'business development',
        slot: 'Sandra is afgestudeerd aan de Business School en het Institute of Investment Management, ze is hardwerkend, toegewijd en met sterke analytische vaardigheden. Binnen Qrespi neemt zij de verantwoordelijkheid voor onze grote accounts en allianties. '
      },
      20: {
        title: 'oprichter & cto',
        slot: 'Mykola heeft een sterke achtergrond als manager in het bouwen van digitale services, het ontwikkelen van cloudgebaseerde web- en mobiele applicaties, E-commerce, Service On-demand, Social Media en Business Tools. Migratie van softwareprojectinfrastructuur naar de AWS of Google Cloud. '
      }
    },
    work: {
      titel: 'Werk met ons',
      caption: 'We hebben een sterke visie om <b>hulpprogramma\'s op maat</b> te ontwikkelen waarmee mensen hun <b>kwaliteit van leven </b>kunnen vergroten.',
      img: 'girl-qstand.jpg',
      interested: 'Een carrière bij Qrespi'
    }
  },
  resources: {
    label: 'informatie',
    press: {
      label: 'Persmap'
    },
    blog: {
      label: 'blog',
      title: 'Blog',
      subtitle: 'Zorg Connecties',
      lead: 'Over Internet of Things en Wederzijdse Zorg',
      read_more: 'Lees meer'
    },
    docs: {
      label: 'documentatie',
      title: 'Qrespi-informatie downloaden',
      subtitle: 'Resource Center',
      lead: 'Praktische gebruiksinformatie, whitepapers, mappen, ...',
      1: {
        label: 'quick start',
        title: 'Snelle installatie-handleiding voor Puck',
        slot: 'Hoe je Puck snel de eerste keer in gebruik stelt'
      },
      2: {
        label: 'folder',
        title: 'Introductie Puck',
        slot: 'Een eerste kennismaking met Puck'
      }
    },
    faq: {
      label: 'veelgestelde vragen',
      title: 'Veelgestelde vragen',
      header: 'Wees op de hoogte',
      lead: 'Wat wil je nog meer?',
      slot: 'Laat het ons weten als je je antwoord niet kunt vinden:',
      1: {
        label: 'Installatiehandleiding?',
        title: 'Hoe stel ik Puck in?',
        slot: 'Puck is heel eenvoudig in te stellen. We hebben het stap voor stap duidelijk gemaakt hoe het moet in een instructie-blad.',
        link: {
          text: 'Bekijk onze snel-start-gids'
        }
      },
      2: {
        label: 'Werkstatus?',
        title: 'Hoe weet ik of Puck werkt? ',
        slot: 'Elke Puck heeft een aantal LEDs de status van het apparaat tonen. Om energie te sparen branden de LEDs alleen voor een korte periode nadat je op de knop drukt. '
      },
      3: {
        label: 'Knipperende rode LEDs?',
        title: 'Wat moet ik doen als de LED rood knippert?',
        slot: 'Als LED op de Puck rood knippert, betekent dit dat er iets misgaat en Puck niet klaar is voor gebruik. '
      },
      // link:
      //   text: 'Raadpleeg onze "trouble-shoot-guide"'
      4: {
        label: 'Minimale kosten?',
        title: 'Wat zijn de minimale kosten die ik zou moeten betalen om Puck te gebruiken?',
        slot: 'Als je maar één Puck installeert en geen extra services instelt, betaal je uitsluitend de Heartbeat-service. De kosten zijn dan ca. 50-80 cent per maand, afhankelijk van de token-bundel die je gebruikt.',
        link: {
          text: 'Schrijf je in op onze vooruit-bestel-lijst'
        }
      },
      5: {
        label: 'Wanneer verzenden?',
        title: 'Weet jij de exacte datum van verzending?',
        slot: 'Tot nu toe zijn we in "pre-orderstatus". Zodra we de Puck-productie starten en je email staat op onze vooruit-bestel-lijst, sturen we je een bericht met een verzenddatum en een instructie voor het kopen van Puck. Wij verwachten rond de zomer 2019.',
        link: {
          text: 'Schrijf je in op onze vooruit-bestel-lijst'
        }
      },
      6: {
        label: 'Installatie?',
        title: 'Kan Puck eenvoudig worden geïnstalleerd?',
        slot: 'Ja, we denken van wel. Puck wordt geleverd met twee magneten op de achterkant. Je kunt Puck aan elk stalen oppervlak bevestigen. Merk op dat roestvrij staal niet altijd voldoende ijzer bevat om Puck te laten kleven. We leveren ook ren metalen plaat met dubbelzijdig klevend plakband voor niet-magnetische oppervlakken. Je kunt het metalen plaatje op elk oppervlak kleven en Puck op deze metalen plaat klikken.'
      },
      7: {
        label: 'Web-account en abonnement?',
        title: 'Heb ik een web-account nodig om Puck te gebruiken?',
        slot: 'Ja, om Puck te gebruiken, moet je de link bezoeken die je op de achterkant van je Puck vindt. Je kunt vervolgens een eigen web-account (profiel) aanmaken waar je Puck registreert en de functionaliteit ervan beheert (tekstberichten instellen / wijzigen, melodieën kiezen, lijsten met geadresseerden van berichten maken / wijzigen, enz.)'
      },
      8: {
        label: 'Maandelijkse kosten?',
        title: 'Is er maandelijkse kosten die ik moet betalen?',
        slot: 'Puck werkt via je wifi, wat je niets extra\'s kost. Wel vraagt iedere Puck 10 tokens heartbeat-kosten per maand om onze communicatieservers dag en nacht operationeel te houden. Deze tokens betaal je uit een pre-paid bundel.'
      },
      9: {
        label: 'WiFi-verbinding?',
        title: 'Heeft Puck een permanente wifi-verbinding nodig?',
        slot: 'Ja, een permanente WiFi-verbinding is vereist voor Puck. Wanneer Puck geen internetverbinding heeft, knippert de LED rood in plaats van groen wanneer je op de knop tikt.'
      },
      10: {
        label: 'Batterijen?',
        title: 'Wat als de batterijen leeg zijn?',
        slot: 'Als de batterijen bijna leeg zijn, knippert de LED rood en krijg je een melding in je privéchat met Puck dat er minder dan 15% stroom is. Als je de batterijen niet vervangt, kan Puck niet werken. '
      },
      11: {
        label: 'Privacy?',
        title: 'Bewaar / bewaar / gebruik je gebruiksinformatie via profiel?',
        slot: 'Nee, dat doen we niet. We bewaren alléén de informatie die je opgeeft in web-account. We gebruiken het alleen om je onze service te bieden; we waarderen privacy net zo veel als u. Alle persoonlijke informatie is gecodeerd en zal niet worden gedeeld met een derde persoon. '
      },
      12: {
        label: 'Garantie?',
        title: 'Wat voor soort garantie biedt u?',
        slot: 'Puck biedt 1 jaar beperkte garantie, wat betekent dat als het apparaat een fabricagefout heeft, we het zullen vervangen als we het geretourneerde product binnen een periode van 1 jaar na de verzenddatum ontvangen. Als het systeem door ondeskundig gebruik is beschadigd, kunnen we het apparaat niet vervangen.'
      }
    }
  },
  career: {
    label: 'carrière'
  },
  footer: {
    copyright: 'copyright ©',
    terms: 'Lorinthe&nbsp;BV Onze algemene voorwaarden zijn van toepassing op al onze diensten'
  },
  not_found: {
    title: 'Sorry, we hebben deze pagina niet gevonden'
  },
  def: {
    yes: 'ja',
    no: 'nee',
    send: 'zenden',
    open: 'open',
    more: 'meer',
    read_more: 'lees meer',
    close: 'sluiten',
    home: 'home',
    buy: 'bestel',
    site: 'site',
    introduction: 'Introductie',
    signup: 'Abonneer',
    submit: 'Verstuur'
  }
}

export {
  nl
}

// # sourceMappingURL=nl.js.map
// # sourceURL=coffeescript
